import { useState } from 'react';

const useLoading = () => {
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);

    return { loading, setLoading, loaded, setLoaded };
}

export default useLoading;